export const colors = {
  light: {
    primary: '#031A6B',
    onPrimary: '#FFFFFF',
    primaryContainer: '#031A6B',
    onPrimaryContainer: '#FFFFFF',
    secondary: '#306669',
    onSecondary: '#FFFFFF',
    secondaryContainer: '#A6DDE0',
    onSecondaryContainer: '#2C6366',
    tertiary: '#00696D',
    onTertiary: '#FFFFFF',
    tertiaryContainer: '#6CDFE5',
    onTertiaryContainer: '#006165',
    error: '#F34666',
    onError: '#FFFFFF',
    errorContainer: '#F34666',
    onErrorContainer: '#FFFFFF',
    background: '#F8EEE5',
    onBackground: '#1B1B20',
    surface: '#F8EEE5',
    onSurface: '#1C1B1B',
    surfaceVariant: '#E9DFD5',
    onSurfaceVariant: '#4C463F',
    outline: '#7B766E',
    outlineVariant: '#CCC6BC',
    shadow: '#000000',
    scrim: '#000000',
    inverseSurface: '#31302F',
    inverseOnSurface: '#F4F0EE',
    inversePrimary: '#B9C3FF',
    regionContainer: '#D8C7B8',
    elevation: {
      level0: 'transparent',
      level1: 'rgb(245, 243, 251)',
      level2: 'rgb(239, 238, 248)',
      level3: 'rgb(234, 233, 246)',
      level4: 'rgb(232, 231, 245)',
      level5: 'rgb(228, 228, 243)'
    },
    surfaceDisabled: 'rgba(27, 27, 31, 0.12)',
    onSurfaceDisabled: 'rgba(27, 27, 31, 0.38)',
    backdrop: 'rgba(47, 48, 56, 0.4)',
    surfaceContainer: '#F8EEE5',
    surfaceContainerLow: '#F7F3F1',
    surfaceContainerLowest: '#FFFFFF',
    surfaceContainerHigh: '#ECE7E5',
    surfaceContainerHighest: '#E6E1E0',
    onSurfaceContainer: 'rgb(40, 25, 0)',
    surfaceVariantContainer: '#FFFFFF',
    onSurfaceVariantContainer: 'rgb(35, 27, 0)'
  },
  dark: {
    primary: '#D3BCFD',
    onPrimary: '#38265C',
    primaryContainer: '#4F3D74',
    onPrimaryContainer: '#EBDDFF',
    secondary: '#CDC2DB',
    onSecondary: '#342D40',
    secondaryContainer: '#4B4358',
    onSecondaryContainer: '#E9DEF8',
    tertiary: '#F0B7C5',
    onTertiary: '#4A2530',
    tertiaryContainer: '#643B46',
    onTertiaryContainer: '#FFD9E1',
    error: '#FFB4AB',
    onError: '#690005',
    errorContainer: '#93000A',
    onErrorContainer: '#FFDAD6',
    background: '#151218',
    onBackground: '#E7E0E8',
    surface: '#151218',
    onSurface: '#E7E0E8',
    surfaceVariant: '#49454E',
    onSurfaceVariant: '#CBC4CF',
    outline: '#948F99',
    outlineVariant: '#49454E',
    shadow: '#000000',
    scrim: '#000000',
    inverseSurface: '#E7E0E8',
    inverseOnSurface: '#322F35',
    inversePrimary: '#68548E',
    regionContainer: '#4A3F33',
    elevation: {
      level0: 'transparent',
      level1: 'rgba(255,255,255,0.03)',
      level2: 'rgba(255,255,255,0.05)',
      level3: 'rgba(255,255,255,0.06)',
      level4: 'rgba(255,255,255,0.07)',
      level5: 'rgba(255,255,255,0.08)'
    },
    surfaceDisabled: 'rgba(255,255,255,0.12)',
    onSurfaceDisabled: 'rgba(255,255,255,0.38)',
    backdrop: 'rgba(0,0,0,0.6)',
    surfaceContainer: '#0F161C',
    surfaceContainerLow: '#0D1318',
    surfaceContainerLowest: '#07090B',
    surfaceContainerHigh: '#16191A',
    surfaceContainerHighest: '#151A20',
    onSurfaceContainer: 'rgb(215,208,200)',
    surfaceVariantContainer: '#0E1416',
    onSurfaceVariantContainer: 'rgb(220,214,207)'
  }
};
